/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  margin-top: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY3VzdG9tLWF1dG9jb21wbGV0ZS9jb21wb25lbnRzL2F1dG9jb21wbGV0ZS1jYW5kaWRhdGUvYXV0b2NvbXBsZXRlLWNhbmRpZGF0ZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9jdXN0b20tYXV0b2NvbXBsZXRlL2NvbXBvbmVudHMvYXV0b2NvbXBsZXRlLWNhbmRpZGF0ZS9hdXRvY29tcGxldGUtY2FuZGlkYXRlLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/custom-autocomplete/components/autocomplete-candidate/autocomplete-candidate.component.scss.shim.ngstyle.ts